module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact"
  }, [_c('form', {
    staticClass: "form-contact__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-contact__group form-contact__group--half"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "form-contact__label",
    class: {
      'form-contact__label--active': _vm.firstName
    }
  }, [_vm._v("First Name *")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstName')),
      expression: "errors.has('firstName')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v("Your first name is required.")])]), _c('div', {
    staticClass: "form-contact__group form-contact__group--half"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "form-contact__label",
    class: {
      'form-contact__label--active': _vm.lastName
    }
  }, [_vm._v("Last Name *")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastName')),
      expression: "errors.has('lastName')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v("Your last name is required.")])]), _c('div', {
    staticClass: "form-contact__group form-contact__group--half"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientEmail),
      expression: "clientEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('clientEmail')
    },
    attrs: {
      "name": "clientEmail"
    },
    domProps: {
      "value": (_vm.clientEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientEmail = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "form-contact__label",
    class: {
      'form-contact__label--active': _vm.clientEmail
    }
  }, [_vm._v("Your Email Address *")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientEmail')),
      expression: "errors.has('clientEmail')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v(" Please input a valid Email")])]), _c('div', {
    staticClass: "form-contact__group form-contact__group--half"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientPhone),
      expression: "clientPhone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('clientPhone')
    },
    attrs: {
      "name": "clientPhone"
    },
    domProps: {
      "value": (_vm.clientPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientPhone = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "form-contact__label",
    class: {
      'form-contact__label--active': _vm.clientPhone
    }
  }, [_vm._v("Your Phone Number *")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientPhone')),
      expression: "errors.has('clientPhone')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v(" Please input a valid number")])]), _c('div', {
    staticClass: "form-contact__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientMessage),
      expression: "clientMessage"
    }],
    staticClass: "form-contact__input form-contact__input--textarea",
    attrs: {
      "name": "clientMessage"
    },
    domProps: {
      "value": (_vm.clientMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientMessage = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "form-contact__label form-contact__label--textarea",
    class: {
      'form-contact__label--active': _vm.clientMessage
    }
  }, [_vm._v("Message")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientMessage')),
      expression: "errors.has('clientMessage')"
    }],
    staticClass: "form-contact__error-message"
  }, [_vm._v(" Please fill out your message")])]), _c('div', {
    staticClass: "form-contact__group form-contact__group--button"
  }, [_c('div', {
    staticClass: "form-contact__submit-button",
    class: {
      'form-contact__submit-button--success': _vm.formSuccess
    },
    on: {
      "click": _vm.validate
    }
  }, [_c('div', {
    staticClass: "form-contact__submit-overlay",
    class: {
      'form-contact__submit-overlay--showing': _vm.formSubmitted && !_vm.formSuccess
    }
  }), _c('span', {
    staticClass: "form-contact__submit-label",
    class: {
      'form-contact__submit-label--hidden': _vm.formSuccess
    }
  }, [_vm._v("SUBMIT")]), _c('div', {
    staticClass: "form-contact__submit-success",
    class: {
      'form-contact__submit-success--showing': _vm.formSuccess
    }
  }), _c('span', {
    staticClass: "form-contact__submit-check",
    class: {
      'form-contact__submit-check--showing': _vm.formSuccess
    }
  }, [_vm._v("✓")])])])]), _c('div', {
    staticClass: "form-contact__modal",
    class: {
      'form-contact__modal--showing': _vm.modalShowing
    }
  }, [_c('div', {
    staticClass: "form-contact__modal-overlay"
  }), _c('div', {
    staticClass: "form-contact__modal-container"
  }, [_c('div', {
    staticClass: "form-contact__modal-close",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("close")]), _c('h1', {
    staticClass: "form-contact__modal-title"
  }, [_vm._v("Thank you! We will be in touch shortly!")]), _vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ed034d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/form.pug
// module id = 580
// module chunks = 1